<template>
  <div
    class="fences-cell"
    :style="{ width: cellSize + 'px', height: cellSize + 'px' }"
  >
    <svg
      class="fences-svg"
      viewBox="0 0 100 100"
      shape-rendering="crispEdges"
      style="overflow: visible"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        v-for="(edge, i) in visibleEdges"
        :key="i"
        :x1="edge.x1"
        :y1="edge.y1"
        :x2="edge.x2"
        :y2="edge.y2"
        :stroke="edge.stroke"
        stroke-width="8"
      />

      <circle
        cx="0"
        cy="0"
        r="8"
        fill="#555555"
        shape-rendering="geometricPrecision"
      />
      <circle
        cx="100"
        cy="0"
        r="8"
        fill="#555555"
        shape-rendering="geometricPrecision"
      />
      <circle
        cx="100"
        cy="100"
        r="8"
        fill="#555555"
        shape-rendering="geometricPrecision"
      />
      <circle
        cx="0"
        cy="100"
        r="8"
        fill="#555555"
        shape-rendering="geometricPrecision"
      />
    </svg>
  </div>
</template>

<script>
const COORDS = {
  top: {
    x1: 0, y1: 0, x2: 100, y2: 0,
  },
  right: {
    x1: 100, y1: 0, x2: 100, y2: 100,
  },
  bottom: {
    x1: 0, y1: 100, x2: 100, y2: 100,
  },
  left: {
    x1: 0, y1: 0, x2: 0, y2: 100,
  },
};

const DIRS = ['top', 'right', 'bottom', 'left'];

export default {
  name: 'FencesCell',
  props: {
    cell: { type: Object, required: true },
    cellSize: { type: Number, default: 60 },
    settings: {
      type: Object,
      default: () => ({ showAnswer: true, colored: false }),
    },
  },
  computed: {
    visibleEdges() {
      const { cell, settings } = this;

      const resolveColor = cellColor => (settings.colored && cellColor ? cellColor : '#000000');

      return DIRS.reduce((lines, dir) => {
        if (cell.fixedEdges[dir]) {
          return [
            ...lines,
            { ...COORDS[dir], stroke: resolveColor(cell.fixedEdgeColors[dir]) },
          ];
        }
        if (cell.extraEdges[dir]) {
          return [
            ...lines,
            { ...COORDS[dir], stroke: resolveColor(cell.extraEdgeColors[dir]) },
          ];
        }
        if (settings.showAnswer && cell.edges[dir]) {
          return [
            ...lines,
            { ...COORDS[dir], stroke: resolveColor(cell.edgeColors[dir]) },
          ];
        }
        return lines;
      }, []);
    },
  },
};
</script>

<style scoped>
.fences-cell {
  position: relative;
}
.fences-svg {
  width: 100%;
  height: 100%;
}
</style>
